var deferImages = {
    load:function(){
        this.useWebp = this.supportWebp();
        this.loadObservers();

    }, 
    supportWebp:function(){
        var elem = document.createElement('canvas');

        if (!!(elem.getContext && elem.getContext('2d')))
        {
            return elem.toDataURL('image/webp').indexOf('data:image/webp') == 0;
        }
        else
        {
         
         return false;
        }
    },
    imageExists:async function(src){
        var result = await new Promise((resolve,reject)=>{
            var image = new Image();
            image.onload = () => {
                resolve(true);
                
            }

            image.onerror = () => {
                resolve(false);
            }

            image.src = src;
        });
        return result;
        
    },
    loadObservers:async function(){ 
        var observer = new IntersectionObserver(async function(entries,observer){
            entries.forEach(async (e)=>{ 
                
                if(e.isIntersecting){
                    if(e.target.getAttribute("data-defer-bgimage")){
                        if(e.target.getAttribute("data-nowebp") || !deferImages.useWebp){
                            e.target.style.backgroundImage = "url('"+e.target.getAttribute("data-defer-bgimage")+"')";
                        }
                        else{
                            var webpsrc = e.target.getAttribute("data-defer-bgimage").replace(".jpg",".webp").replace(".jpeg",".webp").replace(".png",".webp");
                            var exists = await deferImages.imageExists(webpsrc);
                            if(exists){
                                
                                e.target.style.backgroundImage = " url('"+webpsrc+"')"; 
                            }
                            else{
                                
                                e.target.style.backgroundImage = "url('/webp/?i="+e.target.getAttribute("data-defer-bgimage")+"'), url('"+e.target.getAttribute("data-defer-bgimage")+"')";
                            }
                        }
                        e.target.removeAttribute("data-defer-bgimage");
                        
                    }
                    else if(e.target.getAttribute("data-defer-image")){
                        if(e.target.getAttribute("data-nowebp") || !deferImages.useWebp){
                            e.target.src = e.target.getAttribute("data-defer-image");
                        }
                        else{
                            var webpsrc = e.target.getAttribute("data-defer-image").replace(".jpg",".webp").replace(".jpeg",".webp").replace(".png",".webp");
                            var exists = await deferImages.imageExists(webpsrc);
                            if(exists){
                                
                                e.target.src = webpsrc;
                            }
                            else{
                                
                                e.target.src =  e.target.getAttribute("data-defer-image");
                            }
                        }
                        e.target.removeAttribute("data-defer-image");
                    }
                    
                    observer.unobserve(e.target);
                }
                
            });
            
        });
 
        var els1 = document.querySelectorAll("[data-defer-bgimage]");
        var els2 = document.querySelectorAll("[data-defer-image]");
        var els = [...els1,...els2];
        for(let e of els){
            if(!e.getAttribute("data-observing")){
                observer.observe(e);
                e.setAttribute("data-observing","true");
            }
            
        }
    }
};